import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    clarity?: ((command: string, ...args: any[]) => void) & {
      q?: any[];
    };
  }
}

interface ClarityAnalyticsProps {
  projectId: string;
}

const ALLOWED_HOSTS = new Set(['frieght.com', 'www.frieght.com', 'localhost']);

const ClarityAnalytics: React.FC<ClarityAnalyticsProps> = ({ projectId }) => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    if (!projectId || !ALLOWED_HOSTS.has(window.location.hostname)) return;
    if (document.querySelector(`script[data-clarity-project="${projectId}"]`)) return;

    window.clarity =
      window.clarity ||
      function (...args: any[]) {
        (window.clarity!.q = window.clarity!.q || []).push(args as any);
      };

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.clarity.ms/tag/${projectId}`;
    script.dataset.clarityProject = projectId;
    document.head.appendChild(script);
  }, [projectId]);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    if (!ALLOWED_HOSTS.has(window.location.hostname)) return;
    if (typeof window.clarity !== 'function') return;

    try {
      window.clarity('set', 'page', `${location.pathname}${location.search}`);
    } catch (err) {
      if (import.meta.env.DEV) {
        console.warn('[ClarityAnalytics] Failed to track page view', err);
      }
    }
  }, [location.pathname, location.search]);

  return null;
};

export default ClarityAnalytics;
